export default "/6fec15c31a693b89cad5448a82992b2f.jpg";